var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.558716,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 20.0587C11.75 19.2303 12.4216 18.5587 13.25 18.5587C14.0784 18.5587 14.75 19.2303 14.75 20.0587V27.0587C14.75 27.8871 14.0784 28.5587 13.25 28.5587C12.4216 28.5587 11.75 27.8871 11.75 27.0587V20.0587Z",
    fill: "#00AAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 18.0587C16.25 17.2303 16.9216 16.5587 17.75 16.5587C18.5784 16.5587 19.25 17.2303 19.25 18.0587V27.0587C19.25 27.8871 18.5784 28.5587 17.75 28.5587C16.9216 28.5587 16.25 27.8871 16.25 27.0587V18.0587Z",
    fill: "#00AAEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 16.0587C20.75 15.2303 21.4216 14.5587 22.25 14.5587C23.0784 14.5587 23.75 15.2303 23.75 16.0587V27.0587C23.75 27.8871 23.0784 28.5587 22.25 28.5587C21.4216 28.5587 20.75 27.8871 20.75 27.0587V16.0587Z",
    fill: "#00AAEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 14.0587C25.25 13.2303 25.9216 12.5587 26.75 12.5587C27.5784 12.5587 28.25 13.2303 28.25 14.0587V27.0587C28.25 27.8871 27.5784 28.5587 26.75 28.5587C25.9216 28.5587 25.25 27.8871 25.25 27.0587V14.0587Z",
    fill: "#00AAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/masters.230bef61472551b6c3b64856667f10cf.svg";
export { ForwardRef as ReactComponent };